import { render, staticRenderFns } from "./ComingSoonModule.vue?vue&type=template&id=aab445c2"
import script from "./ComingSoonModule.vue?vue&type=script&lang=js"
export * from "./ComingSoonModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports